__turbopack_context__.v({
  "checkboxItem": "filterCheckboxGroup-module-scss-module__YTimtW__checkboxItem",
  "checkboxOptions": "filterCheckboxGroup-module-scss-module__YTimtW__checkboxOptions",
  "checked": "filterCheckboxGroup-module-scss-module__YTimtW__checked",
  "colorInput": "filterCheckboxGroup-module-scss-module__YTimtW__colorInput",
  "counter": "filterCheckboxGroup-module-scss-module__YTimtW__counter",
  "dropdown": "filterCheckboxGroup-module-scss-module__YTimtW__dropdown",
  "filterCheckboxHeader": "filterCheckboxGroup-module-scss-module__YTimtW__filterCheckboxHeader",
  "filterCheckboxWrapper": "filterCheckboxGroup-module-scss-module__YTimtW__filterCheckboxWrapper",
  "opened": "filterCheckboxGroup-module-scss-module__YTimtW__opened",
  "search": "filterCheckboxGroup-module-scss-module__YTimtW__search",
  "searchIcon": "filterCheckboxGroup-module-scss-module__YTimtW__searchIcon",
  "searchInput": "filterCheckboxGroup-module-scss-module__YTimtW__searchInput",
  "title": "filterCheckboxGroup-module-scss-module__YTimtW__title",
});
